import { LoadingContainer, LoadingSpinner } from './styled';

export const Loading = () => (
    <LoadingContainer>
        <LoadingSpinner />
    </LoadingContainer>
);
